import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=e8b9790e&scoped=true"
import script from "./documents.vue?vue&type=script&lang=js"
export * from "./documents.vue?vue&type=script&lang=js"
import style0 from "./documents.vue?vue&type=style&index=0&id=e8b9790e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b9790e",
  null
  
)

export default component.exports